export default {
      id: "tab-fuel-usage",
      viewBox: "0 0 24 26",
      url: __webpack_public_path__ + "img/icons.svg#tab-fuel",
      toString: function () {
        return this.url;
      }
    }